export const Roles = {
  Admin: {
    name: 'Admin',
  },
  Teacher: {
    name: 'Nauczyciel'
  }
};

Object.freeze(Roles);